/**
 * @class Oskari.mapframework.bundle.userguide.request.ShowUserGuideRequest
 *
 *
 */
Oskari.clazz.define('Oskari.mapframework.bundle.userguide.request.ShowUserGuideRequest', function (conf) {
  var config = conf || {};
  this._creator = null;
  this._el = config.el;
  this._context = config.context;
  this._extension = config.extension;
  this._toggle = config.toggle;
  this._placement = config.placement;
  this._content = config.content;
}, {
  __name: 'userguide.ShowUserGuideRequest',
  getName: function getName() {
    return this.__name;
  },
  getUuid: function getUuid() {
    return this._uuid;
  },
  getContext: function getContext() {
    return this._context;
  },
  getExtension: function getExtension() {
    return this._extension;
  },
  getEl: function getEl() {
    return this._el;
  },
  isToggle: function isToggle() {
    return this._toggle;
  },
  getPlacement: function getPlacement() {
    return this._placement;
  },
  getContent: function getContent() {
    return this._content;
  }
}, {
  'protocol': ['Oskari.mapframework.request.Request']
});

/* Inheritance */